import { render, staticRenderFns } from "./DepartmentCategorySidebar.vue?vue&type=template&id=702f669c&scoped=true&"
import script from "./DepartmentCategorySidebar.vue?vue&type=script&lang=js&"
export * from "./DepartmentCategorySidebar.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentCategorySidebar.vue?vue&type=style&index=0&id=702f669c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f669c",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DepartmentTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fdepartment%2FDepartmentCategorySidebar.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports